"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CHAIN_NAME = exports.DEFAULT_CHAIN_ID = exports.FURO_SUBGRAPH_URL = exports.FURO_SUBGRAPH_NAME = exports.FURO_ENABLED_NETWORKS = exports.BENTOBOX_ENABLED_NETWORKS = exports.BENTOBOX_SUBGRAPH_URL = exports.SUBGRAPH_HOST = exports.CHAIN_NAME = exports.DECENTRALIZED_NETWORK_HOST = exports.SUSHI_DEDICATED_GOLDSKY_HOST = exports.SUSHI_GOLDSKY_HOST = exports.HAQQ_HOST = exports.LINEA_HOST = exports.CORE_HOST = exports.THUNDERCORE_HOST = exports.STUDIO_HOST = exports.PENDING_METIS_HOST = exports.METIS_HOST = exports.PENDING_KAVA_HOST = exports.KAVA_HOST = exports.PENDING_GRAPH_HOST = exports.GRAPH_HOST = exports.SWAP_ENABLED_NETWORKS = exports.SUSHISWAP_V3_ENABLED_NETWORKS = exports.SUSHISWAP_ENABLED_NETWORKS = exports.TRIDENT_ENABLED_NETWORKS = void 0;
const chain_1 = require("@sushiswap/chain");
exports.TRIDENT_ENABLED_NETWORKS = [
    chain_1.ChainId.OPTIMISM,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.KAVA,
    chain_1.ChainId.METIS,
    chain_1.ChainId.BTTC,
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
];
exports.SUSHISWAP_ENABLED_NETWORKS = [
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
    chain_1.ChainId.CELO,
    chain_1.ChainId.ETHEREUM,
    chain_1.ChainId.FANTOM,
    chain_1.ChainId.FUSE,
    chain_1.ChainId.GNOSIS,
    chain_1.ChainId.MOONBEAM,
    chain_1.ChainId.MOONRIVER,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.HARMONY,
    chain_1.ChainId.ARBITRUM_NOVA,
    chain_1.ChainId.BOBA,
    chain_1.ChainId.BOBA_AVAX,
    chain_1.ChainId.BOBA_BNB,
    chain_1.ChainId.BASE,
    // ChainId.PALM,
    // ChainId.HECO,
    // ChainId.OKEX
];
exports.SUSHISWAP_V3_ENABLED_NETWORKS = [
    chain_1.ChainId.ETHEREUM,
    chain_1.ChainId.ARBITRUM_NOVA,
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
    chain_1.ChainId.BOBA,
    chain_1.ChainId.FANTOM,
    chain_1.ChainId.FUSE,
    chain_1.ChainId.GNOSIS,
    chain_1.ChainId.MOONRIVER,
    chain_1.ChainId.OPTIMISM,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.POLYGON_ZKEVM,
    chain_1.ChainId.THUNDERCORE,
    chain_1.ChainId.CORE,
    chain_1.ChainId.BASE,
    chain_1.ChainId.LINEA,
];
exports.SWAP_ENABLED_NETWORKS = Array.from(new Set([...exports.SUSHISWAP_ENABLED_NETWORKS, ...exports.SUSHISWAP_V3_ENABLED_NETWORKS, ...exports.TRIDENT_ENABLED_NETWORKS]));
exports.GRAPH_HOST = 'api.thegraph.com/subgraphs/name';
exports.PENDING_GRAPH_HOST = 'api.thegraph.com/subgraphs/id';
exports.KAVA_HOST = 'pvt.graph.kava.io/subgraphs/name';
exports.PENDING_KAVA_HOST = 'pvt.graph.kava.io/subgraphs/id';
exports.METIS_HOST = 'andromeda.thegraph.metis.io/subgraphs/name';
exports.PENDING_METIS_HOST = 'andromeda.thegraph.metis.io/subgraphs/id';
exports.STUDIO_HOST = 'api.studio.thegraph.com/query/32073';
exports.THUNDERCORE_HOST = 'graph-node.thundercore.com/subgraphs/name';
exports.CORE_HOST = 'thegraph.coredao.org/subgraphs/name';
exports.LINEA_HOST = 'graph-query.linea.build/subgraphs/name';
exports.HAQQ_HOST = 'haqq.graph.p2p.org/subgraphs/name';
exports.SUSHI_GOLDSKY_HOST = 'api.goldsky.com/api/public/project_cls39ugcfyhbq01xl9tsf6g38/subgraphs';
exports.SUSHI_DEDICATED_GOLDSKY_HOST = 'api.goldsky.com/api/public/project_clslspm3c0knv01wvgfb2fqyq/subgraphs';
const FURO_SUSHI_DOMAIN_RESTRICTED_API_KEY = '5869e28ab54f5a09a4e2456dd05bd275';
exports.DECENTRALIZED_NETWORK_HOST = `gateway-arbitrum.network.thegraph.com/api/${process.env['SUSHI_GRAPH_KEY'] ?? FURO_SUSHI_DOMAIN_RESTRICTED_API_KEY}/subgraphs/id`;
exports.CHAIN_NAME = {
    [chain_1.ChainId.ARBITRUM]: 'Arbitrum',
    [chain_1.ChainId.AVALANCHE]: 'Avalanche',
    [chain_1.ChainId.BSC]: 'Bsc',
    [chain_1.ChainId.ETHEREUM]: 'Ethereum',
    [chain_1.ChainId.FANTOM]: 'Fantom',
    [chain_1.ChainId.GNOSIS]: 'Gnosis',
    [chain_1.ChainId.GÖRLI]: 'Görli',
    [chain_1.ChainId.HARMONY]: 'Harmony',
    [chain_1.ChainId.MOONBEAM]: 'Moonbeam',
    [chain_1.ChainId.MOONRIVER]: 'Moonriver',
    [chain_1.ChainId.OPTIMISM]: 'Optimism',
    [chain_1.ChainId.POLYGON]: 'Polygon',
    [chain_1.ChainId.TELOS]: 'Telos',
    [chain_1.ChainId.CELO]: 'Celo',
    [chain_1.ChainId.FUSE]: 'Fuse',
    [chain_1.ChainId.OKEX]: 'OKEx',
    [chain_1.ChainId.HECO]: 'HECO',
    [chain_1.ChainId.PALM]: 'Palm',
    [chain_1.ChainId.KAVA]: 'Kava',
    [chain_1.ChainId.METIS]: 'Metis',
    [chain_1.ChainId.BOBA]: 'Boba',
    [chain_1.ChainId.ARBITRUM_NOVA]: 'Arbitrum Nova',
    [chain_1.ChainId.BOBA_AVAX]: 'Boba Avax',
    [chain_1.ChainId.BOBA_BNB]: 'Boba BNB',
    [chain_1.ChainId.BTTC]: 'BitTorrent',
    [chain_1.ChainId.THUNDERCORE]: 'ThunderCore',
    [chain_1.ChainId.POLYGON_ZKEVM]: 'Polygon zkEVM',
    [chain_1.ChainId.CORE]: 'Core',
    [chain_1.ChainId.BASE]: 'Base',
    [chain_1.ChainId.LINEA]: 'Linea',
    [chain_1.ChainId.HAQQ]: 'HAQQ',
};
exports.SUBGRAPH_HOST = {
    [chain_1.ChainId.ARBITRUM]: exports.GRAPH_HOST,
    [chain_1.ChainId.ARBITRUM_NOVA]: exports.SUSHI_DEDICATED_GOLDSKY_HOST,
    [chain_1.ChainId.AVALANCHE]: exports.GRAPH_HOST,
    [chain_1.ChainId.BSC]: exports.GRAPH_HOST,
    [chain_1.ChainId.CELO]: exports.GRAPH_HOST,
    [chain_1.ChainId.ETHEREUM]: exports.GRAPH_HOST,
    [chain_1.ChainId.FANTOM]: exports.GRAPH_HOST,
    [chain_1.ChainId.FUSE]: exports.GRAPH_HOST,
    [chain_1.ChainId.GNOSIS]: exports.GRAPH_HOST,
    [chain_1.ChainId.GÖRLI]: exports.GRAPH_HOST,
    [chain_1.ChainId.HARMONY]: exports.GRAPH_HOST,
    [chain_1.ChainId.KAVA]: exports.KAVA_HOST,
    [chain_1.ChainId.METIS]: exports.METIS_HOST,
    [chain_1.ChainId.MOONBEAM]: exports.GRAPH_HOST,
    [chain_1.ChainId.MOONRIVER]: exports.GRAPH_HOST,
    [chain_1.ChainId.OPTIMISM]: exports.GRAPH_HOST,
    [chain_1.ChainId.POLYGON]: exports.GRAPH_HOST,
    [chain_1.ChainId.POLYGON_ZKEVM]: exports.STUDIO_HOST,
    [chain_1.ChainId.BOBA]: exports.GRAPH_HOST,
    [chain_1.ChainId.BOBA_AVAX]: exports.SUSHI_DEDICATED_GOLDSKY_HOST,
    [chain_1.ChainId.BOBA_BNB]: exports.SUSHI_DEDICATED_GOLDSKY_HOST,
    [chain_1.ChainId.BTTC]: exports.SUSHI_DEDICATED_GOLDSKY_HOST,
    [chain_1.ChainId.OKEX]: '',
    [chain_1.ChainId.HECO]: '',
    [chain_1.ChainId.KOVAN]: '',
    [chain_1.ChainId.THUNDERCORE]: exports.THUNDERCORE_HOST,
    [chain_1.ChainId.CORE]: exports.CORE_HOST,
    [chain_1.ChainId.BASE]: exports.STUDIO_HOST,
    [chain_1.ChainId.LINEA]: exports.LINEA_HOST,
    [chain_1.ChainId.HAQQ]: exports.HAQQ_HOST,
};
// export const BENTOBOX_SUBGRAPH_URL: Record<number, string> = {
//   [ChainId.ETHEREUM]: `${GRAPH_HOST}/sushiswap/bentobox-ethereum`,
//   [ChainId.POLYGON]: `${GRAPH_HOST}/sushiswap/bentobox-polygon`,
//   [ChainId.AVALANCHE]: `${GRAPH_HOST}/sushiswap/bentobox-avalanche`,
//   [ChainId.BSC]: `${GRAPH_HOST}/sushiswap/bentobox-bsc`,
//   [ChainId.FANTOM]: `${GRAPH_HOST}/sushiswap/bentobox-fantom`,
//   [ChainId.GNOSIS]: `${GRAPH_HOST}/sushiswap/bentobox-gnosis`,
//   [ChainId.ARBITRUM]: `${GRAPH_HOST}/sushiswap/bentobox-arbitrum`,
//   [ChainId.CELO]: `${GRAPH_HOST}/sushiswap/bentobox-celo`,
//   [ChainId.MOONRIVER]: `${GRAPH_HOST}/sushiswap/bentobox-moonriver`,
//   [ChainId.MOONBEAM]: `${GRAPH_HOST}/sushiswap/bentobox-moonbeam`,
//   [ChainId.OPTIMISM]: `${GRAPH_HOST}/sushiswap/bentobox-optimism`,
//   [ChainId.HARMONY]: `${GRAPH_HOST}/sushiswap/bentobox-harmony`,
//   [ChainId.BTTC]: `${SUSHI_DEDICATED_GOLDSKY_HOST}/sushiswap/bentobox-bttc/gn`,
// }
exports.BENTOBOX_SUBGRAPH_URL = {
    [chain_1.ChainId.ETHEREUM]: `${exports.DECENTRALIZED_NETWORK_HOST}/8HYeoDopVqqvb5RJEV2TtSzFsouYPz8cownnG3mbhiGy`,
    [chain_1.ChainId.POLYGON]: `${exports.DECENTRALIZED_NETWORK_HOST}/6kJg5kFoQY8B8Ge2hqswHMqZDcmsR1TLUUz7AKov69fy`,
    [chain_1.ChainId.AVALANCHE]: `${exports.DECENTRALIZED_NETWORK_HOST}/EhYaJodF1WQjKgxx1ZC63goeCwp5swD4AQRdaKXBm2xk`,
    [chain_1.ChainId.BSC]: `${exports.DECENTRALIZED_NETWORK_HOST}/BggyE3r5snDsjx19jgZcbiBH7cbtrkpjvyGLFHMdXekd`,
    [chain_1.ChainId.FANTOM]: `${exports.DECENTRALIZED_NETWORK_HOST}/AWD9Ca7KNZg7grfWosKTRqZTjPrJVgS5P5b37pDpN4CT`,
    [chain_1.ChainId.GNOSIS]: `${exports.DECENTRALIZED_NETWORK_HOST}/9jn9kA6SKCNxXQSqb93zZPLdLaru4FeZBwLNWAK4nfZ2`,
    [chain_1.ChainId.ARBITRUM]: `${exports.DECENTRALIZED_NETWORK_HOST}/JZFyMKR4jnsFQ58q7dT6nbXenTzNgE176zTejc6Gf8Z`,
    [chain_1.ChainId.CELO]: `${exports.DECENTRALIZED_NETWORK_HOST}/5DwkvjxPGVFFaWEMM68g1yztDdhCgJEYAxS6FuhkajzR`,
    [chain_1.ChainId.MOONRIVER]: `${exports.DECENTRALIZED_NETWORK_HOST}/73XEV6UQKpPSJn68WZBAYTwALcZtFJkFYn58ZoZUb7tn`,
    [chain_1.ChainId.MOONBEAM]: `${exports.DECENTRALIZED_NETWORK_HOST}/7wA5gqWNP4E1dPWBsTYvz5eQSDbtYDFgyU5BGdHr2UKp`,
    [chain_1.ChainId.OPTIMISM]: `${exports.DECENTRALIZED_NETWORK_HOST}/8b4Hy4Kn7jCNAf9JFrqHb24LsqmapG4HrAsCrwdJf9Nu`,
    [chain_1.ChainId.HARMONY]: `${exports.DECENTRALIZED_NETWORK_HOST}/Bioj7N3Rf2n7iBq9PVoaMie3WiuzPze9NMi7aSye7LFc`,
    [chain_1.ChainId.BTTC]: `${exports.SUSHI_DEDICATED_GOLDSKY_HOST}/sushiswap/bentobox-bttc/gn`,
};
exports.BENTOBOX_ENABLED_NETWORKS = Object.keys(exports.BENTOBOX_SUBGRAPH_URL).map(Number);
exports.FURO_ENABLED_NETWORKS = [
    chain_1.ChainId.ETHEREUM,
    chain_1.ChainId.ARBITRUM,
    chain_1.ChainId.AVALANCHE,
    chain_1.ChainId.BSC,
    chain_1.ChainId.FANTOM,
    chain_1.ChainId.GNOSIS,
    chain_1.ChainId.HARMONY,
    chain_1.ChainId.MOONBEAM,
    chain_1.ChainId.MOONRIVER,
    chain_1.ChainId.OPTIMISM,
    chain_1.ChainId.POLYGON,
    chain_1.ChainId.HAQQ,
    chain_1.ChainId.CORE,
    chain_1.ChainId.THUNDERCORE,
    chain_1.ChainId.BTTC
];
exports.FURO_SUBGRAPH_NAME = {
    [chain_1.ChainId.ETHEREUM]: 'sushi-subgraphs/furo-ethereum',
    [chain_1.ChainId.ARBITRUM]: 'sushi-subgraphs/furo-arbitrum',
    [chain_1.ChainId.AVALANCHE]: 'sushi-subgraphs/furo-avalanche',
    [chain_1.ChainId.BSC]: 'sushi-subgraphs/furo-bsc',
    [chain_1.ChainId.FANTOM]: 'sushi-subgraphs/furo-fantom',
    [chain_1.ChainId.GNOSIS]: 'sushi-subgraphs/furo-gnosis',
    [chain_1.ChainId.HARMONY]: 'sushi-subgraphs/furo-harmony',
    [chain_1.ChainId.MOONBEAM]: 'sushi-subgraphs/furo-moonbeam',
    [chain_1.ChainId.MOONRIVER]: 'sushi-subgraphs/furo-moonriver',
    [chain_1.ChainId.OPTIMISM]: 'sushi-subgraphs/furo-optimism',
    [chain_1.ChainId.POLYGON]: 'sushi-subgraphs/furo-polygon',
    [chain_1.ChainId.HAQQ]: 'sushi/furo-haqq',
    [chain_1.ChainId.CORE]: 'sushi-subgraphs/furo-core',
    [chain_1.ChainId.THUNDERCORE]: 'sushi-subgraphs/furo-thundercore',
    [chain_1.ChainId.BTTC]: 'sushi-subgraphs/furo-bttc/gn'
};
// export const FURO_SUBGRAPH_URL: Record<string, string> = {
//   [ChainId.ETHEREUM]: `${GRAPH_HOST}/sushi-subgraphs/furo-ethereum`,
//   [ChainId.ARBITRUM]: `${GRAPH_HOST}/sushi-subgraphs/furo-arbitrum`,
//   [ChainId.AVALANCHE]: `${GRAPH_HOST}/sushi-subgraphs/furo-avalanche`,
//   [ChainId.BSC]: `${GRAPH_HOST}/sushi-subgraphs/furo-bsc`,
//   [ChainId.FANTOM]: `${GRAPH_HOST}/sushi-subgraphs/furo-fantom`,
//   [ChainId.GNOSIS]: `${GRAPH_HOST}/sushi-subgraphs/furo-gnosis`,
//   [ChainId.HARMONY]: `${GRAPH_HOST}/sushi-subgraphs/furo-harmony`,
//   [ChainId.MOONBEAM]: `${GRAPH_HOST}/sushi-subgraphs/furo-moonbeam`,
//   [ChainId.MOONRIVER]: `${GRAPH_HOST}/sushi-subgraphs/furo-moonriver`,
//   [ChainId.OPTIMISM]: `${GRAPH_HOST}/sushi-subgraphs/furo-optimism`,
//   [ChainId.POLYGON]: `${GRAPH_HOST}/sushi-subgraphs/furo-polygon`,
//   [ChainId.HAQQ]: `${HAQQ_HOST}/sushi/furo-haqq`,
//   [ChainId.CORE]: `${CORE_HOST}/sushi-subgraphs/furo-core`,
//   [ChainId.THUNDERCORE]: `${THUNDERCORE_HOST}/sushi-subgraphs/furo-thundercore`,
//   [ChainId.BTTC]: `${SUSHI_DEDICATED_GOLDSKY_HOST}/sushi-subgraphs/furo-bttc/gn`
// } as const
exports.FURO_SUBGRAPH_URL = {
    [chain_1.ChainId.ETHEREUM]: `${exports.DECENTRALIZED_NETWORK_HOST}/D8vYJpKN5SEHUkUWKSuorsL6FRt7hAQMnywnC4e93ygf`,
    [chain_1.ChainId.ARBITRUM]: `${exports.DECENTRALIZED_NETWORK_HOST}/8eHhPeKDr646JH5KUBBcabAJzkWmLfu6pqBtpXQHa37F`,
    [chain_1.ChainId.AVALANCHE]: `${exports.DECENTRALIZED_NETWORK_HOST}/8LVoX3JPEVAak8T8GoEfdJudMoP2bsGwd9tszJxo3Rnx`,
    [chain_1.ChainId.BSC]: `${exports.DECENTRALIZED_NETWORK_HOST}/2wBYezghRA3hEJLQB4njUZGDNxCdU3u2gsLP5yVvBqKk`,
    [chain_1.ChainId.FANTOM]: `${exports.DECENTRALIZED_NETWORK_HOST}/E98zSR5UZBGBgQe2SSLZ5R6yj5GPqKDJcQJNDHTeV3cS`,
    [chain_1.ChainId.GNOSIS]: `${exports.DECENTRALIZED_NETWORK_HOST}/5ToxB5xubMh9osdEDeX98JBAyzUVwkReGXAT1CzQhZCB`,
    [chain_1.ChainId.HARMONY]: `${exports.DECENTRALIZED_NETWORK_HOST}/9D9C3ppoDE1zuZk5adznngKomLYS8NnC9zxniSS8vzgH`,
    [chain_1.ChainId.MOONBEAM]: `${exports.DECENTRALIZED_NETWORK_HOST}/HJxpcsmaPV3L6PsqGFBHLczeMnL7bEgmL1D65edGx8pf`,
    [chain_1.ChainId.MOONRIVER]: `${exports.DECENTRALIZED_NETWORK_HOST}/9ZqdKjfu7o9dX1RThXHDV9EqMn5CTvgpsPKKbpANg8yC`,
    [chain_1.ChainId.OPTIMISM]: `${exports.DECENTRALIZED_NETWORK_HOST}/8KnsmppMf9k6Qvyixxwmny7dYugTV7XT4htHTfyq3d69`,
    [chain_1.ChainId.POLYGON]: `${exports.DECENTRALIZED_NETWORK_HOST}/4KsDNsyJjKX6bjwVNJQmJ7Dm3wovYXSX37UR39rNaMX4`,
    [chain_1.ChainId.HAQQ]: `${exports.HAQQ_HOST}/sushi/furo-haqq`,
    [chain_1.ChainId.CORE]: `${exports.CORE_HOST}/sushi-subgraphs/furo-core`,
    [chain_1.ChainId.THUNDERCORE]: `${exports.THUNDERCORE_HOST}/sushi-subgraphs/furo-thundercore`,
    [chain_1.ChainId.BTTC]: `${exports.SUSHI_DEDICATED_GOLDSKY_HOST}/sushi-subgraphs/furo-bttc/gn`
};
exports.DEFAULT_CHAIN_ID = chain_1.ChainId.ETHEREUM;
exports.DEFAULT_CHAIN_NAME = exports.CHAIN_NAME[exports.DEFAULT_CHAIN_ID];
//# sourceMappingURL=index.js.map